import { createRoutine } from 'redux-saga-routines';

export const fetchPosTrackingMethods = createRoutine(
  'FETCH_POS_TRACKING_METHODS'
);

export const fetchPosTrackingMethodLocations = createRoutine(
  'FETCH_POS_TRACKING_METHOD_LOCATIONS'
);

export const fetchPosLocationsForTrackingMethod = createRoutine(
  'FETCH_POS_LOCATIONS_FOR_TRACKING_METHOD'
);

export const createPosLocationsForTrackingMethod = createRoutine(
  'CREATE_POS_LOCATIONS_FOR_TRACKING_METHOD'
);

export const deletePosLocationsForTrackingMethod = createRoutine(
  'DELETE_POS_LOCATIONS_FOR_TRACKING_METHOD'
);
